export const INITIALIZE_APP = 'INITIALIZE_APP';
export const GET_LOGIN_USER_DATA = 'GET_LOGIN_USER_DATA';
export const GET_CONFIG_DATA = 'GET_CONFIG_DATA';
export const GET_MEMBER_DATA = 'GET_MEMBER_DATA';
export const GET_MEMBERS_WITH_AUTHORITY_DATA = 'GET_MEMBERS_WITH_AUTHORITY_DATA';
export const GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA = 'GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA';

export const SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST = 'SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST';
export const SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW = 'SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW';
export const SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE = 'SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE';
export const SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE = 'SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE';
// export const SUBMIT_USER_EXCEPTION_DATA = 'SUBMIT_USER_EXCEPTION_DATA';

export const SUBMIT_MEMBER_EDIT_DATA = 'SUBMIT_MEMBER_EDIT_DATA';

export const SUBMIT_JOB_CREATE_DATA = 'SUBMIT_JOB_CREATE_DATA';
export const SUBMIT_JOB_EDIT_DATA = 'SUBMIT_JOB_EDIT_DATA';
export const SUBMIT_JOB_REMOVE_DATA = 'SUBMIT_JOB_REMOVE_DATA';

export const SUBMIT_TEAM_CREATE_DATA = 'SUBMIT_TEAM_CREATE_DATA';
export const SUBMIT_TEAM_EDIT_DATA = 'SUBMIT_TEAM_EDIT_DATA';
export const SUBMIT_TEAM_REMOVE_DATA = 'SUBMIT_TEAM_REMOVE_DATA';
export const SUBMIT_ADD_MEMBER_TO_TEAM_DATA = 'SUBMIT_ADD_MEMBER_TO_TEAM_DATA';
// system submit
export const SET_SLACK_ALARM = 'SET_SLACK_ALARM';



// WEBPACK FOOTER //
// ./src/store/actions-types.js